import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { PricingInvoiceHistoryFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/blocs/documents/pricing-invoice-history-fragment.generated';
import { PricingPeerGroupFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/screens/management/blocs/documents/variant-pack-cost-change-data-fragments.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetPricingRecommendationsDocument = gql`
  query GetPricingRecommendations($taskTypeUUID: uuid!) {
    getPricingRecommendationsForBusinessOrganization(
      task_type_id: $taskTypeUUID
    ) {
      auto_publish_at
      progress {
        accepted
        overridden
        pending
        rejected
      }
      publish_enabled
      recommendations {
        created_at
        gross_profit_in_percentage
        invoice_history {
          ...PricingInvoiceHistoryFields
        }
        new_price_in_micros
        published_at
        peer_group {
          ...PricingPeerGroupFields
        }
        reasoning
        restaurant {
          name
          uuid
        }
        restaurant_account_id
        restaurant_id
        review_status
        snapshot_cost_in_micros
        snapshot_gross_profit_in_percentage
        snapshot_price_in_micros
        supplier_id
        task_run_id
        uuid
        variant_pack {
          external_item_id
          item {
            display_name
          }
          pack {
            unit
          }
          uuid
        }
        weekly_gp_impact_in_micros
        weekly_volume
      }
    }
  }
  ${PricingInvoiceHistoryFieldsFragmentDoc}
  ${PricingPeerGroupFieldsFragmentDoc}
`;
export function useGetPricingRecommendationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >(GetPricingRecommendationsDocument, options);
}
export function useGetPricingRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >(GetPricingRecommendationsDocument, options);
}
export type GetPricingRecommendationsQueryHookResult = ReturnType<
  typeof useGetPricingRecommendationsQuery
>;
export type GetPricingRecommendationsLazyQueryHookResult = ReturnType<
  typeof useGetPricingRecommendationsLazyQuery
>;
export type GetPricingRecommendationsQueryResult = Apollo.QueryResult<
  Types.GetPricingRecommendationsQuery,
  Types.GetPricingRecommendationsQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingRecommendationsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingRecommendationsQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >(GetPricingRecommendationsDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingRecommendationsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingRecommendationsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingRecommendationsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingRecommendationsQuery,
    Types.GetPricingRecommendationsQueryVariables
  >(GetPricingRecommendationsDocument, lazyOptions);
}
